import React from "react";
import {
    Div
} from '@vkontakte/vkui';
import cartApi from "../api/CartApi";
import * as constants from "../assets/constants";

class CartTotal  extends React.Component {
    state = {
        total: 0.0,
        baseTotal: 0.0

    };
    getTotal = () => {
        let sum = 0.0, sumWithDiscount = 0.0
        if(cartApi.items) {
            cartApi.items.map((item, index) => {
                sumWithDiscount += item.quantity * (item.price * 1 - (item.discount != undefined && item.discount != 0 ? (item.price / 100 * item.discount) : 0))
                sum += item.quantity * item.price
            })
        }
        this.setState({total: sumWithDiscount, baseTotal: sum})
    }

    constructor(props) {
        super(props);

        /*
                this.changeLogin = this.changeLogin.bind(this);
                this.changePass = this.changePass.bind(this);*/

    }

    componentDidMount() {
        this.getTotal()
        window.addEventListener('message', this.receiveMessage)
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.receiveMessage)
    }

    receiveMessage = (event) => {
        if (event.data == 'cartUpdate') {
            this.getTotal()
        }
    }

    render() {
        return (<Div>
            {!(this.props.user && this.props.user.meta.settings && this.props.user.meta.settings.hide_prices == '1') &&
                <div className="cart-total_grand-total">
                <div className="cart-total_base-total"
                     style={{display: this.state.total.toFixed(2) == this.state.baseTotal.toFixed(2) ? 'none' : 'inherit'}}>
                    {this.state.baseTotal.toFixed(2) + constants.currency_char}
                </div>
                {this.props.title}{this.state.total.toFixed(2) + constants.currency_char}
            </div>}
        </Div>)
    }
}
export default CartTotal